import React, { useEffect } from 'react';
import {
    Box,
    Container, Table, TableBody, TableCell, TableHead, TableRow,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import services from '../services';
import { useStores } from '../hooks/use-stores';
import ShareLinks from '../components/ShareLinks';
import {useTranslation} from "react-i18next";
import InfoIcon from "@material-ui/icons/InfoOutlined";
import ReactMarkdown from "react-markdown";

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        padding: theme.spacing(3),
        color: "white"
    },
    dialogPaper:{
        maxWidth: "800px",
        maxHeight: "60vh",
        [theme.breakpoints.down("sm")]:{
            margin:"5px",
            maxWidth:"unset"
        }
    },
    dialogContent:{
        [theme.breakpoints.down("sm")]:{
            padding:"10px"
        }
    }
}));

const ShareEnrollment = () => {
    const { t } = useTranslation();
    const { authStore, commonStore, } = useStores();
    const classes = useStyles();
    const { currentUser } = authStore;
    const { isSuperApp, isSuperAppPlus, isStarfish } = currentUser;

    const [links, setLinks] = React.useState(null);

    useEffect(() => {
        if (["HT", "AU", "BS"].includes(currentUser?.country)) {
            setLinks([...platformLinks, ...starfishLinks]);
        } else {
            setLinks(starfishLinks);
        }
    }, []);

    const generateLink = async (selection, uplineUserID) => {
        const selectionValue = selection.value;
        const fromStarfish = selectionValue && selectionValue.includes('starfish') ? true : false;

        return (selectionValue === "life")
            ? { url: "https://my.lifeinfoapp.com/starfish/life" }
            : await services.Enrollment.generateEnrollmentLink(selectionValue, 'en', fromStarfish, uplineUserID);
    }

    const hasAccess = React.useMemo(() => {
        if (!!isStarfish || !!isSuperApp || !!isSuperAppPlus) {
            return true;
        } else {
            return false;
        }
    }, [isStarfish, isSuperApp, isSuperAppPlus]);

    const platformLinks = [
        {
            value: 'superapp', text: 'Platform Enrollment',
        },
        {
            value: 'superappplus', text: 'Platform + Enrollment'
        }
    ];

    const starfishLinks = [
        {
            value: 'royal.kit', text: 'Royal + Kit from Company'
        },
        {
            value: 'royal.kitmember', text: 'Royal + Kit from Me'
        },
        {
            value: 'royal.kitupline', text: 'Royal + Kit from My Upline'
        },
        {
            value: 'starfish', text: 'Starfish'
        },
        {
            value: 'starfish.kitonly', text: 'Book Kit Only from Me'
        },
        {
            value: 'royal.kit.fr', text: 'Royal + Kit from Company (French)'
        },
        {
            value: 'royal.kitmember.fr', text: 'Royal + Kit from Me (French)'
        },
        {
            value: 'royal.kitupline.fr', text: 'Royal + Kit from My Upline (French)'
        },
        {
            value: 'starfish.kitonly.fr', text: 'Book Kit Only from Me (French)'
        },
        {
            value: 'royal.kit.es', text: 'Royal + Kit from Company (Spanish) '
        },
        {
            value: 'royal.kitmember.es', text: 'Royal + Kit from Me (Spanish)'
        },
        {
            value: 'royal.kitupline.es', text: 'Royal + Kit from My Upline (Spanish)'
        },
        {
            value: 'starfish.kitonly.es', text: 'Book Kit Only from Me (Spanish)'
        }
    ];

    const showInfoPopup = (e)=>{
        e.stopPropagation();
        e.preventDefault();

        commonStore.showConfirm(<>
                <p className={classes.requirementsDescription}>
                    <ReactMarkdown>
                        {t("starfish:enrollmentDescriptionMarkdown")}
                    </ReactMarkdown>
                </p>

            </>
            , "OK"
            , null
            , null
            , null
            , undefined
            , {hideHeader:true, dialogProps:{ maxWidth:"sm", classes:{paper: classes.dialogPaper}}, dialogContentProps:{ classes: {root: classes.dialogContent}} })
    }

    return (
        <Container maxWidth={"md"} className={classes.root}>
            <ShareLinks
                links={links}
                onGenerateLink={generateLink}
                header={!!currentUser.isMember ? <Box
                    display={"flex"}
                    alignItems={"center"}>{t("Enrollment Links")} <InfoIcon onClick={showInfoPopup} style={{cursor: "pointer", marginLeft:10 }}/></Box> : "Invite Friends"}
                description={!!currentUser.isMember ? t("share:enrollDescription") : ""}
                hasAccess={hasAccess}
            />
        </Container>
    );
};

export default ShareEnrollment;